import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { ILead, Lead } from "@/models/lead.entity";
import leadService from "@/services/mrfiktiv/services/lead.service";
import { MrfiktivLeadControllerFindAllParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const LeadPageDataProvider = new (class extends AbstractPageDataProvider<
  ILead,
  MrfiktivLeadControllerFindAllParamsGen
> {
  itemsPerPage = 100;

  async getPage(query: MrfiktivLeadControllerFindAllParamsGen): Promise<IPageViewModel<ILead>> {
    const res = await leadService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []).map(d => new Lead(d));

    return { meta, data };
  }
})();
